<div class="drag-and-drop-container">
  @if (msg) {
    <div class="message-container">
      <span>{{ msg }}</span>
    </div>
  }

  @if (fileTitle !== '') {
    <div class="file-title">{{ fileTitle }}</div>
  }

  @if (selectedFile && isFileSelected) {
    <div class="selected-file-container">
      @for (doc of documentUploadedList; track doc) {
        <div
        [style.display]="
          documentUploadedList.length > 1
            ? 'flex'
            : 'none'
        "
          class="documents-uploaded-container"
          >
          <div class="file-uploaded-container">
            <div class="img-preview-container">
              @if (doc.name === 'btn' && allowMultipleFiles) {
                <button
                  [disabled]="!enableUploadButton"
                  class="btn-add-another"
                  (click)="openFileBrowser()"
                  >
                  <span class="material-symbols-outlined"> add </span>
                  <span>Add Another</span>
                </button>
              }
              @if (doc.name != 'btn') {
                @if (doc.name.split('.').pop() !== 'pdf') {
                  <img
                    [src]="doc.url"
                    width="150px"
                    class="mat-elevation-z8"
                    />
                }
                @if (doc.name.split('.').pop() === 'pdf') {
                  <img
                    src="assets\images\pdf_icon.svg"
                    width="150px"
                    class="mat-elevation-z8 pdf-icon"
                    />
                }
              }
            </div>
            <div class="try-again-container">
              @if (doc.name != 'btn') {
                <a (click)="clearFile(doc)">Delete</a>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
  <div
    [style.display]="documentUploadedList.length < 2 ? 'flex' : 'none'"
    class="drag-and-drop-box"
    appDragAndDropDirective
    (fileDropped)="onFileDropped($event)"
    >
    <input
      #dragAndDropFileInput
      type="file"
      accept="application/pdf, image/jpeg, image/png, image/jpg"
      (change)="fileBrowseHandler($event.target)"
      />
      <div class="icon">
        <!-- <span class="material-symbols-outlined"> cloud_upload </span> -->

        <div class="cloud-icon-mask"></div>
      </div>
      <div class="info">
        <span>Drag and drop here</span>
        <span>or</span>
        <span><strong>browse</strong></span>
      </div>
    </div>

    @if (documentUploadedList.length < 2) {
      <div
        class="upload-button-box"
        [style.display]="documentUploadedList.length < 2 ? 'flex' : 'none'"
        >
        <!-- <button id="take-picture-btn" (click)="openFileBrowser()">
        Take A Picture
        <img
          src="../../../../assets/images/Make A Change Icon SVG.svg"
          width="35px"
          alt=""
          />
        </button> -->
        <button id="upload-file-btn" (click)="openFileBrowser()">
          Upload A File
          <mat-icon svgIcon="UploadaDocument"></mat-icon>
        </button>
      </div>
    }
  </div>
